const TabsContentTheme = {
  tabsContent: "my-2",
};

export default TabsContentTheme;
